import { Text } from "@redotech/redo-web/text";

import { memo } from "react";

import ChevronRightIcon from "@redotech/redo-icons/chevron-right.svg";
import FlexBottomIcon from "@redotech/redo-icons/flex-align-bottom.svg";
import InfoCircleIcon from "@redotech/redo-icons/info-circle.svg";
import ShoppingCartIcon from "@redotech/redo-icons/shopping-cart-01.svg";
import ToggleIcon from "@redotech/redo-icons/toggle-03-left_filled.svg";
import { WidgetElementType } from "@redotech/redo-storefront-common/widget-config";
import { WidgetConfig } from "@redotech/redo-storefront-widget-common/widget";
import { RedoIcon } from "@redotech/redo-web/arbiter-components/icon/redo-icon";
import { useNavigate } from "react-router-dom";
import * as styles from "../general.module.css";

export const WidgetSelect = memo(function WidgetSelect({
  widgets,
}: {
  widgets: WidgetConfig[];
}) {
  return widgets.map((widget, index) => (
    <WidgetItem index={index} key={widget.name} widget={widget} />
  ));
});

const WidgetItem = memo(function WidgetItem({
  widget,
  index,
}: {
  widget: WidgetConfig;
  index: number;
}) {
  const navigate = useNavigate();

  let widgetIcon = InfoCircleIcon;
  switch (widget.elementType) {
    case WidgetElementType.INFO_CARD:
      widgetIcon = InfoCircleIcon;
      break;
    case WidgetElementType.BOTH_CHECKOUT_BUTTONS:
      widgetIcon = ShoppingCartIcon;
      break;
    case WidgetElementType.COVERAGE_CHECKOUT_BUTTON:
      widgetIcon = ShoppingCartIcon;
      break;
    case WidgetElementType.NON_COVERAGE_CHECKOUT_BUTTON:
      widgetIcon = ShoppingCartIcon;
      break;
    case WidgetElementType.SINGLE_TOGGLE:
      widgetIcon = InfoCircleIcon;
      break;
    case WidgetElementType.CART_CHECKBOX:
      widgetIcon = InfoCircleIcon;
      break;
    case WidgetElementType.DOUBLE_TOGGLE:
      widgetIcon = InfoCircleIcon;
      break;
    case WidgetElementType.CART_CARD:
      widgetIcon = InfoCircleIcon;
      break;
    case WidgetElementType.CHECKOUT_BUTTON:
      widgetIcon = ShoppingCartIcon;
      break;
  }
  return (
    <a
      className={styles.widgetSubsectionItem}
      onClick={() => {
        navigate("../widgets?index=" + index);
      }}
    >
      <div className={styles.widgetSubsectionItemContent}>
        <RedoIcon color="secondary" Icon={widgetIcon} size={20} />
        <Text fontSize="sm" fontWeight="medium" textColor="primary">
          {widget.name}
        </Text>
      </div>
      <RedoIcon color="tertiary" Icon={ChevronRightIcon} size={16} />
    </a>
  );
});

export const ToggleWidgetItem = memo(function ToggleWidgetItem() {
  const navigate = useNavigate();
  return (
    <a
      className={styles.widgetSubsectionItem}
      onClick={() => {
        navigate("../toggle");
      }}
    >
      <div className={styles.widgetSubsectionItemContent}>
        <RedoIcon color="secondary" Icon={ToggleIcon} size={20} />
        <Text fontSize="sm" fontWeight="medium" textColor="primary">
          Toggle
        </Text>
      </div>
      <RedoIcon color="tertiary" Icon={ChevronRightIcon} size={16} />
    </a>
  );
});

export const PDPWidgetItem = memo(function PDPWidgetItem() {
  const navigate = useNavigate();
  return (
    <a
      className={styles.widgetSubsectionItem}
      onClick={() => {
        navigate("../pdp");
      }}
    >
      <div className={styles.widgetSubsectionItemContent}>
        <RedoIcon color="secondary" Icon={FlexBottomIcon} size={20} />
        <Text fontSize="sm" fontWeight="medium" textColor="primary">
          Product Detail Page
        </Text>
      </div>
      <RedoIcon color="tertiary" Icon={ChevronRightIcon} size={16} />
    </a>
  );
});

export const AddWidgetButton = memo(function AddWidgetButton() {
  const navigate = useNavigate();
  return (
    <a
      onClick={() => {
        navigate("../widgets");
      }}
    >
      <button className={styles.addWidgetButton} type="button">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          + Add widget
        </Text>
      </button>
    </a>
  );
});
